/* ============================================================
   PNM v4 — Homepage + Header + Ribbon JS
   All selectors are prefixed (pnm-util-bar, pnm-site-header, etc.)
   to avoid clashing with existing theme scripts.
   ============================================================ */
(function(){
  'use strict';

  // ---------- RIBBON ANIMATION (v1 / v2 / v3) ----------
  var ribbonTimer = null;
  function setRibbonMode(bar, mode){
    if (!bar) return;
    var ribbon = bar.querySelector('.ribbon');
    if (!ribbon) return;
    if (!/^v[123]$/.test(mode)) mode = 'v2';
    bar.setAttribute('data-ribbon-mode', mode);

    if (ribbonTimer) { clearInterval(ribbonTimer); ribbonTimer = null; }
    ribbon.querySelectorAll('.msg.dup').forEach(function(d){ d.remove(); });

    var msgs = ribbon.querySelectorAll('.msg');
    msgs.forEach(function(m){ m.classList.remove('active'); });

    if (mode === 'v1') {
      Array.prototype.slice.call(msgs).forEach(function(m){
        var clone = m.cloneNode(true);
        clone.classList.add('dup');
        ribbon.appendChild(clone);
      });
    } else if (mode === 'v2') {
      if (msgs[0]) msgs[0].classList.add('active');
      var i = 0;
      ribbonTimer = setInterval(function(){
        if (!msgs.length) return;
        msgs[i].classList.remove('active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('active');
      }, 4000);
    }
  }
  var utilBar = document.querySelector('.pnm-util-bar');
  if (utilBar) {
    setRibbonMode(utilBar, utilBar.getAttribute('data-ribbon-mode') || 'v2');
  }

  // ---------- HEADER: transparent over hero, solid white once scrolled past it ----------
  var hero = document.querySelector('.pnm-hero, .pnm-header-alt');
  if (hero) {
    var headerObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.intersectionRatio < 0.4) document.body.classList.add('pnm-header-solid');
        else document.body.classList.remove('pnm-header-solid');
      });
    }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });
    headerObs.observe(hero);
  } else {
    document.body.classList.add('pnm-header-solid');
  }

  // ---------- HEADER: mega-menu open/close + tab switching ----------
  var backdrop = document.querySelector('.pnm-mega-backdrop');
  var siteHeader = document.querySelector('.pnm-site-header');

  function openMega(name){
    closeMega();
    var m = document.getElementById('pnm-mega-' + name);
    if (!m) return;
    m.classList.add('open');
    if (backdrop) backdrop.classList.add('show');
    document.body.classList.add('pnm-mega-open');
    if (name === 'face')  goToTab('face',  'face');
    if (name === 'derma') goToTab('derma', 'derma');
  }
  function closeMega(){
    document.querySelectorAll('.pnm-mega').forEach(function(m){ m.classList.remove('open'); });
    if (backdrop) backdrop.classList.remove('show');
    document.body.classList.remove('pnm-mega-open');
  }
  function goToTab(mega, tab){
    var megaEl = document.getElementById('pnm-mega-' + mega);
    if (!megaEl) return;
    megaEl.querySelectorAll('.rail .tab').forEach(function(t){ t.classList.remove('active'); });
    var tabEl = megaEl.querySelector('.rail .tab[data-tab="' + tab + '"]');
    if (tabEl) tabEl.classList.add('active');
    megaEl.querySelectorAll('.tab-pane').forEach(function(p){ p.classList.remove('active'); });
    var pane = document.getElementById('pnm-' + mega + '-pane-' + tab);
    if (pane) pane.classList.add('active');
  }
  document.querySelectorAll('.pnm-site-header .nav-item.has-mega').forEach(function(item){
    item.addEventListener('mouseenter', function(){ openMega(item.getAttribute('data-mega')); });
    item.addEventListener('click',      function(){ openMega(item.getAttribute('data-mega')); });
  });
  document.querySelectorAll('[data-mega][data-tab]').forEach(function(el){
    el.addEventListener('click', function(e){
      e.preventDefault();
      goToTab(el.getAttribute('data-mega'), el.getAttribute('data-tab'));
    });
  });
  function closeZone(e){
    var t = e.relatedTarget;
    if (!t) return closeMega();
    if (siteHeader && siteHeader.contains(t)) return;
    var inMenu = false;
    document.querySelectorAll('.pnm-mega').forEach(function(m){ if (m.contains(t)) inMenu = true; });
    if (!inMenu) closeMega();
  }
  if (siteHeader) siteHeader.addEventListener('mouseleave', closeZone);
  document.querySelectorAll('.pnm-mega').forEach(function(m){ m.addEventListener('mouseleave', closeZone); });
  if (backdrop) backdrop.addEventListener('click', closeMega);

  // ---------- MOBILE MENU TAKEOVER ----------
  (function(){
    var hamBtn = document.getElementById('pnm-ham-btn');
    var menuEl = document.getElementById('pnm-mobile-menu');
    if (!hamBtn || !menuEl) return;

    function isOpen(){ return document.body.classList.contains('pnm-mm-open'); }
    // Activate the first tab + first pane inside any sub-panel.
    // Generic so it works for both the hardcoded Face fallback and the
    // auto-generated sub-panels driven by the Shopify nav menu.
    function activateFirstTab(sub){
      if (!sub) return;
      var tabs  = sub.querySelectorAll('.pnm-mm-tab');
      var panes = sub.querySelectorAll('.pnm-mm-pane');
      tabs.forEach(function(t){ t.classList.remove('active'); });
      panes.forEach(function(p){ p.hidden = true; });
      if (tabs[0])  tabs[0].classList.add('active');
      if (panes[0]) panes[0].hidden = false;
    }
    function openMM(){
      document.body.classList.add('pnm-mm-open');
      hamBtn.setAttribute('aria-expanded', 'true');
      hamBtn.setAttribute('aria-label', 'Close menu');
    }
    function closeMM(){
      document.body.classList.remove('pnm-mm-open');
      hamBtn.setAttribute('aria-expanded', 'false');
      hamBtn.setAttribute('aria-label', 'Open menu');
      menuEl.querySelectorAll('.pnm-mm-sub.open').forEach(function(s){ s.classList.remove('open'); });
    }

    hamBtn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (isOpen()) closeMM(); else openMM();
    });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && isOpen()) closeMM();
    });

    // Drill-down: any top-level row with data-pnm-mm-sub opens the matching sub-panel
    menuEl.querySelectorAll('[data-pnm-mm-sub]').forEach(function(row){
      row.addEventListener('click', function(){
        var name = row.getAttribute('data-pnm-mm-sub');
        var sub = document.getElementById('pnm-mm-sub-' + name);
        if (sub) {
          sub.classList.add('open');
          activateFirstTab(sub);
        }
      });
    });

    // Back button inside sub-panels
    menuEl.querySelectorAll('[data-pnm-mm-back]').forEach(function(b){
      b.addEventListener('click', function(){
        var sub = b.closest('.pnm-mm-sub');
        if (sub) sub.classList.remove('open');
      });
    });

    // Tab switching — scoped to the sub-panel containing the clicked tab,
    // so tabs in one sub-panel can't accidentally toggle panes in another.
    menuEl.querySelectorAll('[data-pnm-mm-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){
        var sub = tab.closest('.pnm-mm-sub');
        if (!sub) return;
        sub.querySelectorAll('.pnm-mm-tab').forEach(function(t){ t.classList.remove('active'); });
        tab.classList.add('active');
        sub.querySelectorAll('.pnm-mm-pane').forEach(function(p){ p.hidden = true; });
        var pane = document.getElementById('pnm-mm-pane-' + tab.getAttribute('data-pnm-mm-tab'));
        if (pane) pane.hidden = false;
      });
    });
  })();

  // ---------- Reveal-on-scroll ----------
  var revealEls = document.querySelectorAll('.pnm [data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(e){
      e.forEach(function(x){ if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-in'); });
  }

  // ---------- Hero word swap ----------
  var track = document.getElementById('pnm-swap-track');
  if (track) {
    var n = track.children.length, step = 100 / n, i = 0;
    setInterval(function(){
      i++;
      track.style.transform = 'translateY(-' + (i * step) + '%)';
      if (i >= n - 1) {
        setTimeout(function(){
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          i = 0;
          requestAnimationFrame(function(){ requestAnimationFrame(function(){ track.style.transition = ''; }); });
        }, 700);
      }
    }, 2600);
  }

  // ---------- Routine picker (driven by section block data-*) ----------
  var tabs = document.querySelectorAll('.pnm-concerns .tab');
  var panelShot  = document.getElementById('pnm-concern-shot');
  var panelTitle = document.getElementById('pnm-concern-title');
  var panelDesc  = document.getElementById('pnm-concern-desc');
  var panelRecos = document.getElementById('pnm-concern-recos');
  var panelCta   = document.getElementById('pnm-concern-cta');

  function paintFromTab(tab) {
    if (!tab || !panelShot) return;

    var image = tab.getAttribute('data-image') || '';
    var mood  = tab.getAttribute('data-mood')  || 'mood-warm';
    panelShot.className = image ? 'shot' : 'shot ' + mood;
    panelShot.style.backgroundImage    = image ? 'url(' + image + ')' : '';
    panelShot.style.backgroundSize     = image ? 'contain' : '';
    panelShot.style.backgroundPosition = image ? 'center' : '';
    panelShot.style.backgroundRepeat   = image ? 'no-repeat' : '';
    panelShot.innerHTML = '';

    if (panelTitle) panelTitle.textContent = tab.getAttribute('data-title') || '';
    if (panelDesc)  panelDesc.textContent  = tab.getAttribute('data-desc')  || '';
    if (panelCta)   panelCta.setAttribute('href', tab.getAttribute('data-cta') || '#');

    var recos = [];
    try { recos = JSON.parse(tab.getAttribute('data-recos') || '[]'); } catch (e) { recos = []; }
    if (panelRecos) {
      panelRecos.innerHTML = recos.map(function (r) {
        var swatch = r.image
          ? '<span class="swatch" style="background-image:url(' + r.image + ');background-size:cover;background-position:center;"></span>'
          : '<span class="swatch"></span>';
        var priceHtml = (r.price || '');
        if (r.compareAt) priceHtml += ' <s style="opacity:.55;font-weight:400;margin-left:6px;">' + r.compareAt + '</s>';
        return '<li><a href="' + (r.url || '#') + '" style="display:contents;color:inherit;text-decoration:none;">'
             + swatch
             + '<span class="name">' + (r.name || '') + '</span>'
             + '<span class="pr">' + priceHtml + '</span>'
             + '</a></li>';
      }).join('');
    }
  }

  if (tabs.length) {
    var routinePanel = document.querySelector('.pnm-concerns .panel');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        paintFromTab(t);
        // On mobile, scroll the routine detail panel into view after a click.
        if (routinePanel && window.matchMedia && window.matchMedia('(max-width:991px)').matches) {
          requestAnimationFrame(function(){
            routinePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      });
    });
    var initial = document.querySelector('.pnm-concerns .tab.is-active') || tabs[0];
    paintFromTab(initial);
  }

  // ---------- Collection grid: AJAX "Load more" ----------
  document.querySelectorAll('[data-pnm-load-more-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.dataset.loading === '1') return;
      var wrap   = btn.closest('[data-pnm-load-more]');
      var grid   = btn.closest('.pnm-collection-grid').querySelector('[data-pnm-grid]');
      var nextUrl = btn.getAttribute('data-next-url') || btn.href;
      if (!nextUrl || !grid) return;
      btn.dataset.loading = '1';
      var originalLabel = btn.querySelector('[data-pnm-load-more-label]').textContent;
      btn.querySelector('[data-pnm-load-more-label]').textContent = 'Loading…';

      fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('.pnm-collection-grid [data-pnm-grid]');
          if (nextGrid) {
            // Append every product card from the next page (skip break tile dupes).
            nextGrid.querySelectorAll('.product-card').forEach(function (card) {
              grid.appendChild(card);
            });
          }
          // Update progress + button from the response's load-more region.
          var nextLoadMore = doc.querySelector('[data-pnm-load-more]');
          if (nextLoadMore) {
            var nextShown = nextLoadMore.querySelector('[data-pnm-shown]');
            var nextTotal = nextLoadMore.querySelector('[data-pnm-total]');
            var nextFill  = nextLoadMore.querySelector('[data-pnm-fill]');
            var shownEl   = wrap.querySelector('[data-pnm-shown]');
            var totalEl   = wrap.querySelector('[data-pnm-total]');
            var fillEl    = wrap.querySelector('[data-pnm-fill]');
            if (shownEl && nextShown) shownEl.textContent = nextShown.textContent;
            if (totalEl && nextTotal) totalEl.textContent = nextTotal.textContent;
            if (fillEl  && nextFill)  fillEl.style.width  = nextFill.style.width;

            var nextBtn = nextLoadMore.querySelector('[data-pnm-load-more-btn]');
            if (nextBtn) {
              btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url') || '');
              btn.setAttribute('href', nextBtn.getAttribute('href') || '#');
              btn.querySelector('[data-pnm-load-more-label]').textContent =
                nextBtn.querySelector('[data-pnm-load-more-label]').textContent;
            } else {
              btn.remove();
            }
          } else {
            btn.remove();
          }
          btn.dataset.loading = '';
        })
        .catch(function () {
          btn.querySelector('[data-pnm-load-more-label]').textContent = originalLabel;
          btn.dataset.loading = '';
        });
    });
  });

  // ---------- Bestseller rail ----------
  var rail = document.getElementById('pnm-bestsellers-rail');
  var current = document.getElementById('pnm-rail-current');
  var totalEl = document.getElementById('pnm-rail-total');
  var prev = document.getElementById('pnm-rail-prev');
  var next = document.getElementById('pnm-rail-next');
  if (rail && current && totalEl) {
    var cards = rail.querySelectorAll('.product-card');
    totalEl.textContent = String(cards.length).padStart(2, '0');
    function step(){ if (cards.length < 2) return 0; return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left; }
    function updateIndex(){
      var d = step(); if (!d) return;
      var idx = Math.round(rail.scrollLeft / d);
      if (idx < 0) idx = 0; if (idx > cards.length - 1) idx = cards.length - 1;
      current.textContent = String(idx + 1).padStart(2, '0');
      prev.disabled = (idx === 0);
      next.disabled = (idx >= cards.length - 1);
    }
    prev.addEventListener('click', function(){ rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function(){ rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function(){ requestAnimationFrame(updateIndex); }, { passive: true });
    window.addEventListener('resize', updateIndex);
    updateIndex();
  }
})();

/* ============================================================
   RIVO HOMEPAGE HYDRATION
   Personalises the nav points pill + the loyalty CTA section
   for logged-in Rivo customers. Falls back silently otherwise.
   Requires the Rivo JavaScript API to be enabled in:
   https://loyalty.rivo.io/loy/settings/developers
   ============================================================ */
(function () {
  function $(s){ return document.querySelector(s); }
  function fmt(n){ try { return Number(n||0).toLocaleString('en-IE'); } catch(e){ return String(n||0); } }
  function show(el){ if(el) el.removeAttribute('hidden'); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function init(){
    if (!window.RivoJS) return;

    window.RivoJS.getCustomerDetails().then(function (resp) {
      if (!resp || !resp.success) return;
      var c = resp.customer || {};
      var pts = c.points_tally || 0;
      var pretty = c.pretty_points_tally || fmt(pts);

      document.querySelectorAll('.rivo-points-balance').forEach(function (el) { el.textContent = pretty; });
      show($('#rivo-nav-points'));

      var title = $('#rivo-loy-title');
      var sub   = $('#rivo-loy-sub');
      var ctaL  = $('#rivo-loy-cta-label');
      var cta   = $('#rivo-loy-cta');
      if (title) title.innerHTML = 'You have <strong>' + esc(pretty) + '</strong> points to spend.';
      if (sub)   sub.textContent = 'Keep earning every time you shop, review, refer or replenish. Redeem points for money off or complimentary skincare.';
      if (ctaL)  ctaL.textContent = 'Open The Members Edit';
      if (cta)   cta.setAttribute('href', '/pages/members-edit');
    }).catch(function(){});

    window.RivoJS.getCustomerVipTier().then(function (resp) {
      if (!resp || !resp.success) return;
      var tier = resp.tier || {};
      var next = resp.next_tier || null;

      var eyebrow = $('#rivo-loy-eyebrow');
      if (eyebrow && tier.name) eyebrow.textContent = 'The Members Edit · ' + tier.name + ' Member';

      var progress = $('#rivo-loy-progress');
      var fill     = $('#rivo-loy-fill');
      var meta     = $('#rivo-loy-meta');

      if (resp.highest_tier) {
        if (fill) fill.style.width = '100%';
        if (meta) meta.innerHTML = "<strong>You've reached our highest tier</strong> · Enjoy every perk.";
        show(progress);
      } else if (next) {
        var current = tier.threshold || 0;
        var target  = next.threshold  || 0;
        var toGo    = next.to_spend_or_earn || 0;
        var earned  = Math.max(target - toGo, 0);
        var pct     = target > current
          ? Math.min(100, Math.max(0, Math.round((earned - current) / (target - current) * 100)))
          : 0;
        if (fill) fill.style.width = pct + '%';
        if (meta) {
          meta.innerHTML =
            '<span><strong>' + fmt(earned) + '</strong> of ' + fmt(target) + ' pts</span>' +
            '<span>Earn <strong>' + fmt(toGo) + '</strong> more to unlock ' + esc(next.name) + '</span>';
        }
        show(progress);
      }
    }).catch(function(){});

    if (typeof window.RivoJS.getCustomerBestRewardToShow === 'function') {
      window.RivoJS.getCustomerBestRewardToShow().then(function (resp) {
        var best = (resp && (resp.reward || (resp.success && resp.best_reward))) || null;
        if (!best && resp && resp.success && resp.data) best = resp.data;
        if (!best) return;
        var name = best.name || (best.reward && best.reward.name);
        var ptsAmt = best.points_amount || (best.reward && best.reward.points_amount);
        if (!name) return;
        var el = $('#rivo-loy-best');
        if (!el) return;
        el.innerHTML = 'Closest reward · <strong>' + esc(name) + '</strong>' + (ptsAmt ? ' · ' + fmt(ptsAmt) + ' pts' : '');
        show(el);
      }).catch(function(){});
    }
  }

  if (window.RivoJS) init();
  document.addEventListener('rivo-js-loaded', init);
})();

/* =========================================================
   Cart count sync — keep visible .bag-count badges in sync
   with the legacy cart bundle's .cart-count writes.
   The bundle writes the live count to .cart-count (a hidden
   JS hook) but doesn't touch the visible .bag-count spans.
   We watch .cart-count via MutationObserver and mirror its
   value to every .bag-count, hiding the badge at 0. Also
   re-syncs after any /cart/*.js fetch resolves, in case the
   bundle never wrote (e.g. legacy header bridge mismatch).
   ========================================================= */
(function () {
  function syncBagCount(value) {
    var n = parseInt(value, 10);
    if (isNaN(n)) n = 0;
    document.querySelectorAll('.bag-count').forEach(function (el) {
      el.textContent = String(n);
      el.style.display = n > 0 ? '' : 'none';
    });
    /* Also keep the screen-reader-friendly cart count hooks tidy. */
    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.textContent.trim() !== String(n)) el.textContent = String(n);
    });
  }

  function readCanonicalCount() {
    var ref = document.querySelector('#cart-button .cart-count')
           || document.querySelector('.cart-count');
    if (ref) return parseInt(ref.textContent, 10) || 0;
    return 0;
  }

  /* Observe .cart-count (the bundle's write target) → mirror to .bag-count */
  function attachObservers() {
    document.querySelectorAll('.cart-count').forEach(function (target) {
      var mo = new MutationObserver(function () {
        syncBagCount(target.textContent);
      });
      mo.observe(target, { childList: true, characterData: true, subtree: true });
    });
  }

  /* Wrap fetch — every time /cart/*.js completes, re-sync from /cart.js.
     Catches the case where the cart bundle's mutation never fires. */
  if (window.fetch && !window.__pnmCartFetchWrapped) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)\.js/.test(urlStr);
      var ret = origFetch.apply(this, arguments);
      if (isCartMutation) {
        ret.then(function () {
          origFetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d) { if (d) syncBagCount(d.item_count); })
            .catch(function () {});
        }).catch(function () {});
      }
      return ret;
    };
    window.__pnmCartFetchWrapped = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attachObservers(); syncBagCount(readCanonicalCount()); });
  } else {
    attachObservers();
    syncBagCount(readCanonicalCount());
  }
})();

/* =========================================================
   Cart drawer wiring (PNM v4 header)
   - Click on header bag/cart link opens #cart-drawer
   - All ATC paths that call window.cart.add(...) auto-open
     the drawer after the add resolves.
   ========================================================= */
(function () {
  function openCartDrawer() {
    // The cart bundle's DOMContentLoaded init throws on the legacy header's
    // missing elements, so it never attaches item listeners. Calling the
    // (already-defined) cart.refresh re-renders items with their qty/remove
    // listeners. Mirrors the bridge in pdp-v2.js.
    try { if (typeof cart !== 'undefined' && cart && typeof cart.refresh === 'function') cart.refresh(); } catch (e) {}
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.add('active');
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.remove('active');
  }

  document.addEventListener('click', function (e) {
    // Close: the same init throw means the bundle never wires the close
    // button / backdrop, so handle it here.
    if (e.target.closest('#cart-drawer .close-btn') || e.target.matches('#cart-drawer .drawer-back')) {
      closeCartDrawer();
      return;
    }

    var link = e.target.closest('.pnm-site-header .bag-link, .pnm-site-header .nav-right a[href$="/cart"], .pnm-site-header .nav-left a[href$="/cart"]');
    if (!link) return;
    /* B2B has no cart drawer — don't intercept; let the link navigate to the cart page. */
    if (!document.getElementById('cart-drawer')) return;
    e.preventDefault();
    openCartDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  function wrapCartAdd() {
    if (!window.cart || typeof window.cart.add !== 'function' || window.cart.__pnmDrawerWrapped) return false;
    var originalAdd = window.cart.add;
    window.cart.add = function () {
      var p = originalAdd.apply(this, arguments);
      if (p && typeof p.then === 'function') {
        p.then(function () { openCartDrawer(); }).catch(function () {});
      } else {
        openCartDrawer();
      }
      return p;
    };
    window.cart.__pnmDrawerWrapped = true;
    return true;
  }

  if (!wrapCartAdd()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (wrapCartAdd() || ++tries > 40) clearInterval(iv);
    }, 100);
  }

  /* Shared AJAX add helper used by both the grid Quick-add button and the
     product-card Quick-add form. Returns a promise so callers can chain UI. */
  function pnmAjaxAddVariant(variantId, quantity, caseSize) {
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(quantity || 1));
    /* B2B: record the pack multiple as a hidden line property so the cart knows the step. */
    if (caseSize && caseSize > 1) {
      fd.append('properties[_quantity_multiple]', String(caseSize));
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw res.body;
        /* On the cart page (no drawer) reload so the new line shows; elsewhere open the drawer. */
        if (document.querySelector('.pmc-cart')) { window.location.reload(); return res.body; }
        try { if (typeof cart !== 'undefined' && cart && typeof cart.refresh === 'function') cart.refresh(); } catch (e2) {}
        openCartDrawer();
        return res.body;
      });
  }

  /* Quick-add button (every product card across the site — collection grid,
     bestsellers, blog post products, search results, PDP cross-sell, etc.).
     Matches any <button class="quick-add" data-variant-id="..."> OR the
     explicit [data-pnm-grid-quick-add] opt-in. Most cards are nested inside
     <a class="product-card" href="..."> so we must stop the click before it
     bubbles to the anchor — otherwise the browser navigates to the PDP and
     we never get to add anything. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('button.quick-add[data-variant-id], [data-pnm-grid-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    /* B2B: cards carry data-quantity (the product's order-multiple / case size) so
       a quick-add drops a full case in the bag, not a single unit. Defaults to 1. */
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    var originalLabel = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.innerHTML = 'Adding…';
    /* qty is the order-multiple (one full case), so it's also the case size for the line property. */
    pnmAjaxAddVariant(vid, qty, qty)
      .catch(function (err) {
        var msg = (err && err.description) ? err.description : 'Couldn\'t add';
        btn.innerHTML = msg;
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.innerHTML = originalLabel;
        }, 1200);
      });
  }, true); /* capture phase — fires before the anchor's default click. */

  /* Quick-add forms on product cards (snippets/pnm-product-card.liquid).
     Default form submit hits /cart/add and redirects to /cart, which is
     jarring — replace with an AJAX add then open the drawer. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-pnm-quick-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.disabled) return;
    var originalLabel = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.innerHTML = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
    .then(function (res) {
      if (!res.ok) throw res.body;
      try { if (typeof cart !== 'undefined' && cart && typeof cart.refresh === 'function') cart.refresh(); } catch (e2) {}
      openCartDrawer();
    })
    .catch(function (err) {
      var msg = (err && err.description) ? err.description : 'Couldn\'t add to bag — try again.';
      if (btn) { btn.innerHTML = msg; setTimeout(function () { btn.innerHTML = originalLabel; btn.disabled = false; btn.classList.remove('is-loading'); }, 2400); }
    })
    .finally(function () {
      if (btn && !btn.classList.contains('is-loading')) return;
      setTimeout(function () {
        if (!btn) return;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (btn.innerHTML === 'Adding…') btn.innerHTML = originalLabel;
      }, 600);
    });
  });
})();

/* ============================================================
   Copy-link share button — [data-pnm-copy-link]
   Copies the page URL (or data-url override) and flips the icon to ✓
   for 1.6s. Uses navigator.clipboard with a textarea fallback for
   older browsers / insecure contexts.
   ============================================================ */
(function(){
  function fallbackCopy(text){
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly',''); ta.style.position='absolute'; ta.style.left='-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch(_) {}
    document.body.removeChild(ta);
  }
  document.addEventListener('click', function(e){
    var el = e.target.closest && e.target.closest('[data-pnm-copy-link]');
    if (!el) return;
    e.preventDefault();
    var url = el.getAttribute('data-url') || window.location.href;
    var original = el.innerHTML;
    var done = function(){
      el.classList.add('is-copied');
      el.innerHTML = '✓';
      setTimeout(function(){ el.classList.remove('is-copied'); el.innerHTML = original; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function(){ fallbackCopy(url); done(); });
    } else {
      fallbackCopy(url); done();
    }
  }, false);
})();

/* ============================================================
   Native share button — [data-pnm-native-share]
   Triggers the OS share sheet (which on mobile includes Instagram,
   Stories, DMs, etc). Falls back to copy-link behaviour on desktop
   where navigator.share is usually unavailable.
   ============================================================ */
(function(){
  function fallbackCopy(text){
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly',''); ta.style.position='absolute'; ta.style.left='-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch(_) {}
    document.body.removeChild(ta);
  }
  document.addEventListener('click', function(e){
    var el = e.target.closest && e.target.closest('[data-pnm-native-share]');
    if (!el) return;
    e.preventDefault();
    var url = el.getAttribute('data-url') || window.location.href;
    var title = el.getAttribute('data-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function(){});
      return;
    }
    var original = el.innerHTML;
    var done = function(){
      el.classList.add('is-copied');
      el.innerHTML = '✓';
      setTimeout(function(){ el.classList.remove('is-copied'); el.innerHTML = original; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function(){ fallbackCopy(url); done(); });
    } else {
      fallbackCopy(url); done();
    }
  }, false);
})();
